import { atom } from "jotai";
import { Notification } from "shared/models/notification";
/**
 * Primitives
 */

const defaultNotification: Notification = {
  isOpen: false,
  severity: "info",
  message: "",
  inProgress: false,
};

/** This atom handles open/close state of the snackbar notification, its severity level and message */
export const notificationAtom = atom<Notification>(defaultNotification);

//* **************************************************************************************************************** */
/**
 * Derived
 */

/**
 * Helper atom to trigger the notification. It merges information from the
 * default notification so only message or severity can be changed
 */
export const setNotificationAtom = atom(
  null,
  (_, set, updatedNotification: Omit<Partial<Notification>, "isOpen">) => {
    const { inProgress = false } = updatedNotification;
    set(notificationAtom, (previousNotification) => ({
      ...previousNotification,
      ...updatedNotification,
      isOpen: true,
      inProgress,
    }));
  }
);
